import { ZfErrorDialog } from '@bjb-gcrm/gcrm-frontend-components';
import { ZfAccordion, ZfAccordionItem, ZfBox, ZfDivider, ZfStack, ZfTypography } from '@zafire/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type BannerErrorDialogType = {
  title: string;
  showDialog: boolean;
  onDialogClose: () => void;
  error?: Error;
};

const msg =
  "The pre-login handshake acknowledgement couldn't be consumed due to a timeout. This may be due to\n" +
  "                    handshake failure or server's delayed response. Time spent trying to connect to the server was -\n" +
  '                    [Pre-Login] initialisation=0; handshake=15000.';
export const BannerErrorDialog = ({ title, showDialog, onDialogClose, error }: BannerErrorDialogType) => {
  const { t } = useTranslation();
  const errorMessage = useMemo(() => {
    if (error) {
      const result = Object.entries(error).map(([key, value]) => ({
        title: key,
        label: Array.isArray(value) || typeof value === 'object' ? JSON.stringify(value) : value,
      }));
      return result;
    }
    return null;
  }, [error]);

  return (
    <ZfErrorDialog title={title} showDialog={showDialog} onDialogClose={onDialogClose}>
      <ZfErrorDialog.Body>
        <ZfStack spacing="medium">
          <ZfBox style={{ textAlign: 'center' }}>
            <ZfTypography variant="title-large" alignment="center">
              {title}
            </ZfTypography>
          </ZfBox>
          <ZfBox style={{ padding: 'var(--padding-vertical-md, 16px)', textAlign: 'center' }}>
            <ZfTypography variant="label-large" alignment="center">
              {t('pb.errordialog.message')}
            </ZfTypography>
          </ZfBox>

          <ZfDivider />
          <ZfAccordion type="multiple">
            <ZfAccordionItem size="large" titleText={t('pb.errordialog.whatyoucantry.title')} state="active">
              <ZfStack style={{ padding: 'var(--padding-vertical-md, 16px)', gap: 4 }}>
                <ZfBox style={{ display: 'flex', gap: 8 }}>
                  <ZfTypography weight="bold" variant="body-small">
                    {t('pb.errordialog.whatyoucantry.switzerland.label')}
                  </ZfTypography>

                  <ZfTypography variant="body-small">
                    {t('pb.errordialog.whatyoucantry.switzerland.description')}
                  </ZfTypography>
                </ZfBox>
                <ZfBox style={{ display: 'flex', gap: 8 }}>
                  <ZfTypography weight="bold" variant="body-small">
                    {t('pb.errordialog.whatyoucantry.guernsey.label')}
                  </ZfTypography>
                  <ZfTypography variant="body-small">
                    {t('pb.errordialog.whatyoucantry.guernsey.description')}
                  </ZfTypography>
                </ZfBox>
              </ZfStack>
            </ZfAccordionItem>
            <ZfAccordionItem size="large" titleText={t('pb.errordialog.technicaldetails.title')} state="active">
              <ZfStack
                style={{ padding: 'var(--padding-vertical-md, 16px)', gap: 4, overflowY: 'auto', maxHeight: 300 }}
              >
                <ZfBox style={{ display: 'flex', gap: 8 }}>
                  <ZfTypography variant="body-small">{msg}</ZfTypography>
                </ZfBox>
                {errorMessage?.map((item) => (
                  <ZfStack direction="row" key={item.title}>
                    <ZfTypography style={{ flex: 1 }}>{item.title}</ZfTypography>
                    <ZfTypography style={{ flex: 1 }}>{item.label}</ZfTypography>
                  </ZfStack>
                ))}
              </ZfStack>
            </ZfAccordionItem>
          </ZfAccordion>
        </ZfStack>
      </ZfErrorDialog.Body>
    </ZfErrorDialog>
  );
};
